/** @license React v16.8.3
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

var p = require("object-assign"),
    q = require("react");

function aa(a, b, d, c, f, e, h, g) {
  if (!a) {
    a = void 0;
    if (void 0 === b) a = Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
      var D = [d, c, f, e, h, g],
          B = 0;
      a = Error(b.replace(/%s/g, function () {
        return D[B++];
      }));
      a.name = "Invariant Violation";
    }
    a.framesToPop = 1;
    throw a;
  }
}

function r(a) {
  for (var b = arguments.length - 1, d = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 0; c < b; c++) {
    d += "&args[]=" + encodeURIComponent(arguments[c + 1]);
  }

  aa(!1, "Minified React error #" + a + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", d);
}

var v = "function" === typeof Symbol && Symbol.for,
    ba = v ? Symbol.for("react.portal") : 60106,
    x = v ? Symbol.for("react.fragment") : 60107,
    ca = v ? Symbol.for("react.strict_mode") : 60108,
    da = v ? Symbol.for("react.profiler") : 60114,
    z = v ? Symbol.for("react.provider") : 60109,
    ea = v ? Symbol.for("react.context") : 60110,
    fa = v ? Symbol.for("react.concurrent_mode") : 60111,
    ha = v ? Symbol.for("react.forward_ref") : 60112,
    A = v ? Symbol.for("react.suspense") : 60113,
    ia = v ? Symbol.for("react.memo") : 60115,
    ja = v ? Symbol.for("react.lazy") : 60116;

function C(a) {
  if (null == a) return null;
  if ("function" === typeof a) return a.displayName || a.name || null;
  if ("string" === typeof a) return a;

  switch (a) {
    case fa:
      return "ConcurrentMode";

    case x:
      return "Fragment";

    case ba:
      return "Portal";

    case da:
      return "Profiler";

    case ca:
      return "StrictMode";

    case A:
      return "Suspense";
  }

  if ("object" === typeof a) switch (a.$$typeof) {
    case ea:
      return "Context.Consumer";

    case z:
      return "Context.Provider";

    case ha:
      var b = a.render;
      b = b.displayName || b.name || "";
      return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");

    case ia:
      return C(a.type);

    case ja:
      if (a = 1 === a._status ? a._result : null) return C(a);
  }
  return null;
}

var E = q.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
E.hasOwnProperty("ReactCurrentDispatcher") || (E.ReactCurrentDispatcher = {
  current: null
});
var ka = {};

function F(a, b) {
  for (var d = a._threadCount | 0; d <= b; d++) {
    a[d] = a._currentValue2, a._threadCount = d + 1;
  }
}

function la(a, b, d) {
  var c = a.contextType;
  if ("object" === typeof c && null !== c) return F(c, d), c[d];

  if (a = a.contextTypes) {
    d = {};

    for (var f in a) {
      d[f] = b[f];
    }

    b = d;
  } else b = ka;

  return b;
}

for (var G = new Uint16Array(16), H = 0; 15 > H; H++) {
  G[H] = H + 1;
}

G[15] = 0;
var ma = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
    na = Object.prototype.hasOwnProperty,
    oa = {},
    pa = {};

function qa(a) {
  if (na.call(pa, a)) return !0;
  if (na.call(oa, a)) return !1;
  if (ma.test(a)) return pa[a] = !0;
  oa[a] = !0;
  return !1;
}

function ra(a, b, d, c) {
  if (null !== d && 0 === d.type) return !1;

  switch (typeof b) {
    case "function":
    case "symbol":
      return !0;

    case "boolean":
      if (c) return !1;
      if (null !== d) return !d.acceptsBooleans;
      a = a.toLowerCase().slice(0, 5);
      return "data-" !== a && "aria-" !== a;

    default:
      return !1;
  }
}

function sa(a, b, d, c) {
  if (null === b || "undefined" === typeof b || ra(a, b, d, c)) return !0;
  if (c) return !1;
  if (null !== d) switch (d.type) {
    case 3:
      return !b;

    case 4:
      return !1 === b;

    case 5:
      return isNaN(b);

    case 6:
      return isNaN(b) || 1 > b;
  }
  return !1;
}

function I(a, b, d, c, f) {
  this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
  this.attributeName = c;
  this.attributeNamespace = f;
  this.mustUseProperty = d;
  this.propertyName = a;
  this.type = b;
}

var J = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (a) {
  J[a] = new I(a, 0, !1, a, null);
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (a) {
  var b = a[0];
  J[b] = new I(b, 1, !1, a[1], null);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function (a) {
  J[a] = new I(a, 2, !1, a.toLowerCase(), null);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (a) {
  J[a] = new I(a, 2, !1, a, null);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (a) {
  J[a] = new I(a, 3, !1, a.toLowerCase(), null);
});
["checked", "multiple", "muted", "selected"].forEach(function (a) {
  J[a] = new I(a, 3, !0, a, null);
});
["capture", "download"].forEach(function (a) {
  J[a] = new I(a, 4, !1, a, null);
});
["cols", "rows", "size", "span"].forEach(function (a) {
  J[a] = new I(a, 6, !1, a, null);
});
["rowSpan", "start"].forEach(function (a) {
  J[a] = new I(a, 5, !1, a.toLowerCase(), null);
});
var K = /[\-:]([a-z])/g;

function L(a) {
  return a[1].toUpperCase();
}

"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (a) {
  var b = a.replace(K, L);
  J[b] = new I(b, 1, !1, a, null);
});
"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (a) {
  var b = a.replace(K, L);
  J[b] = new I(b, 1, !1, a, "http://www.w3.org/1999/xlink");
});
["xml:base", "xml:lang", "xml:space"].forEach(function (a) {
  var b = a.replace(K, L);
  J[b] = new I(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace");
});
["tabIndex", "crossOrigin"].forEach(function (a) {
  J[a] = new I(a, 1, !1, a.toLowerCase(), null);
});
var ta = /["'&<>]/;

function M(a) {
  if ("boolean" === typeof a || "number" === typeof a) return "" + a;
  a = "" + a;
  var b = ta.exec(a);

  if (b) {
    var d = "",
        c,
        f = 0;

    for (c = b.index; c < a.length; c++) {
      switch (a.charCodeAt(c)) {
        case 34:
          b = "&quot;";
          break;

        case 38:
          b = "&amp;";
          break;

        case 39:
          b = "&#x27;";
          break;

        case 60:
          b = "&lt;";
          break;

        case 62:
          b = "&gt;";
          break;

        default:
          continue;
      }

      f !== c && (d += a.substring(f, c));
      f = c + 1;
      d += b;
    }

    a = f !== c ? d + a.substring(f, c) : d;
  }

  return a;
}

var N = null,
    O = null,
    P = null,
    Q = !1,
    S = !1,
    T = null,
    U = 0;

function V() {
  null === N ? r("307") : void 0;
  return N;
}

function ua() {
  0 < U && r("312");
  return {
    memoizedState: null,
    queue: null,
    next: null
  };
}

function W() {
  null === P ? null === O ? (Q = !1, O = P = ua()) : (Q = !0, P = O) : null === P.next ? (Q = !1, P = P.next = ua()) : (Q = !0, P = P.next);
  return P;
}

function va(a, b, d, c) {
  for (; S;) {
    S = !1, U += 1, P = null, d = a(b, c);
  }

  O = N = null;
  U = 0;
  P = T = null;
  return d;
}

function wa(a, b) {
  return "function" === typeof b ? b(a) : b;
}

function xa(a, b, d) {
  N = V();
  P = W();

  if (Q) {
    var c = P.queue;
    b = c.dispatch;

    if (null !== T && (d = T.get(c), void 0 !== d)) {
      T.delete(c);
      c = P.memoizedState;

      do {
        c = a(c, d.action), d = d.next;
      } while (null !== d);

      P.memoizedState = c;
      return [c, b];
    }

    return [P.memoizedState, b];
  }

  a = a === wa ? "function" === typeof b ? b() : b : void 0 !== d ? d(b) : b;
  P.memoizedState = a;
  a = P.queue = {
    last: null,
    dispatch: null
  };
  a = a.dispatch = ya.bind(null, N, a);
  return [P.memoizedState, a];
}

function ya(a, b, d) {
  25 > U ? void 0 : r("301");
  if (a === N) if (S = !0, a = {
    action: d,
    next: null
  }, null === T && (T = new Map()), d = T.get(b), void 0 === d) T.set(b, a);else {
    for (b = d; null !== b.next;) {
      b = b.next;
    }

    b.next = a;
  }
}

function za() {}

var X = 0,
    Aa = {
  readContext: function readContext(a) {
    var b = X;
    F(a, b);
    return a[b];
  },
  useContext: function useContext(a) {
    V();
    var b = X;
    F(a, b);
    return a[b];
  },
  useMemo: function useMemo(a, b) {
    N = V();
    P = W();
    b = void 0 === b ? null : b;

    if (null !== P) {
      var d = P.memoizedState;

      if (null !== d && null !== b) {
        a: {
          var c = d[1];
          if (null === c) c = !1;else {
            for (var f = 0; f < c.length && f < b.length; f++) {
              var e = b[f],
                  h = c[f];

              if ((e !== h || 0 === e && 1 / e !== 1 / h) && (e === e || h === h)) {
                c = !1;
                break a;
              }
            }

            c = !0;
          }
        }

        if (c) return d[0];
      }
    }

    a = a();
    P.memoizedState = [a, b];
    return a;
  },
  useReducer: xa,
  useRef: function useRef(a) {
    N = V();
    P = W();
    var b = P.memoizedState;
    return null === b ? (a = {
      current: a
    }, P.memoizedState = a) : b;
  },
  useState: function useState(a) {
    return xa(wa, a);
  },
  useLayoutEffect: function useLayoutEffect() {},
  useCallback: function useCallback(a) {
    return a;
  },
  useImperativeHandle: za,
  useEffect: za,
  useDebugValue: za
},
    Ba = {
  html: "http://www.w3.org/1999/xhtml",
  mathml: "http://www.w3.org/1998/Math/MathML",
  svg: "http://www.w3.org/2000/svg"
};

function Ca(a) {
  switch (a) {
    case "svg":
      return "http://www.w3.org/2000/svg";

    case "math":
      return "http://www.w3.org/1998/Math/MathML";

    default:
      return "http://www.w3.org/1999/xhtml";
  }
}

var Da = {
  area: !0,
  base: !0,
  br: !0,
  col: !0,
  embed: !0,
  hr: !0,
  img: !0,
  input: !0,
  keygen: !0,
  link: !0,
  meta: !0,
  param: !0,
  source: !0,
  track: !0,
  wbr: !0
},
    Ea = p({
  menuitem: !0
}, Da),
    Y = {
  animationIterationCount: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridArea: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
},
    Fa = ["Webkit", "ms", "Moz", "O"];
Object.keys(Y).forEach(function (a) {
  Fa.forEach(function (b) {
    b = b + a.charAt(0).toUpperCase() + a.substring(1);
    Y[b] = Y[a];
  });
});
var Ga = /([A-Z])/g,
    Ha = /^ms-/,
    Z = q.Children.toArray,
    Ia = E.ReactCurrentDispatcher,
    Ja = {
  listing: !0,
  pre: !0,
  textarea: !0
},
    Ka = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,
    La = {},
    Ma = {};

function Na(a) {
  if (void 0 === a || null === a) return a;
  var b = "";
  q.Children.forEach(a, function (a) {
    null != a && (b += a);
  });
  return b;
}

var Oa = Object.prototype.hasOwnProperty,
    Pa = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null,
  suppressHydrationWarning: null
};

function Qa(a, b) {
  void 0 === a && r("152", C(b) || "Component");
}

function Ra(a, b, d) {
  function c(c, f) {
    var e = la(f, b, d),
        g = [],
        h = !1,
        l = {
      isMounted: function isMounted() {
        return !1;
      },
      enqueueForceUpdate: function enqueueForceUpdate() {
        if (null === g) return null;
      },
      enqueueReplaceState: function enqueueReplaceState(a, b) {
        h = !0;
        g = [b];
      },
      enqueueSetState: function enqueueSetState(a, b) {
        if (null === g) return null;
        g.push(b);
      }
    },
        k = void 0;

    if (f.prototype && f.prototype.isReactComponent) {
      if (k = new f(c.props, e, l), "function" === typeof f.getDerivedStateFromProps) {
        var t = f.getDerivedStateFromProps.call(null, c.props, k.state);
        null != t && (k.state = p({}, k.state, t));
      }
    } else if (N = {}, k = f(c.props, e, l), k = va(f, c.props, k, e), null == k || null == k.render) {
      a = k;
      Qa(a, f);
      return;
    }

    k.props = c.props;
    k.context = e;
    k.updater = l;
    l = k.state;
    void 0 === l && (k.state = l = null);
    if ("function" === typeof k.UNSAFE_componentWillMount || "function" === typeof k.componentWillMount) if ("function" === typeof k.componentWillMount && "function" !== typeof f.getDerivedStateFromProps && k.componentWillMount(), "function" === typeof k.UNSAFE_componentWillMount && "function" !== typeof f.getDerivedStateFromProps && k.UNSAFE_componentWillMount(), g.length) {
      l = g;
      var m = h;
      g = null;
      h = !1;
      if (m && 1 === l.length) k.state = l[0];else {
        t = m ? l[0] : k.state;
        var u = !0;

        for (m = m ? 1 : 0; m < l.length; m++) {
          var w = l[m];
          w = "function" === typeof w ? w.call(k, t, c.props, e) : w;
          null != w && (u ? (u = !1, t = p({}, t, w)) : p(t, w));
        }

        k.state = t;
      }
    } else g = null;
    a = k.render();
    Qa(a, f);
    c = void 0;

    if ("function" === typeof k.getChildContext && (e = f.childContextTypes, "object" === typeof e)) {
      c = k.getChildContext();

      for (var R in c) {
        R in e ? void 0 : r("108", C(f) || "Unknown", R);
      }
    }

    c && (b = p({}, b, c));
  }

  for (; q.isValidElement(a);) {
    var f = a,
        e = f.type;
    if ("function" !== typeof e) break;
    c(f, e);
  }

  return {
    child: a,
    context: b
  };
}

var Sa = function () {
  function a(b, d) {
    if (!(this instanceof a)) throw new TypeError("Cannot call a class as a function");
    q.isValidElement(b) ? b.type !== x ? b = [b] : (b = b.props.children, b = q.isValidElement(b) ? [b] : Z(b)) : b = Z(b);
    b = {
      type: null,
      domNamespace: Ba.html,
      children: b,
      childIndex: 0,
      context: ka,
      footer: ""
    };
    var c = G[0];

    if (0 === c) {
      var f = G;
      c = f.length;
      var e = 2 * c;
      65536 >= e ? void 0 : r("304");
      var h = new Uint16Array(e);
      h.set(f);
      G = h;
      G[0] = c + 1;

      for (f = c; f < e - 1; f++) {
        G[f] = f + 1;
      }

      G[e - 1] = 0;
    } else G[0] = G[c];

    this.threadID = c;
    this.stack = [b];
    this.exhausted = !1;
    this.currentSelectValue = null;
    this.previousWasTextNode = !1;
    this.makeStaticMarkup = d;
    this.suspenseDepth = 0;
    this.contextIndex = -1;
    this.contextStack = [];
    this.contextValueStack = [];
  }

  a.prototype.destroy = function () {
    if (!this.exhausted) {
      this.exhausted = !0;
      this.clearProviders();
      var a = this.threadID;
      G[a] = G[0];
      G[0] = a;
    }
  };

  a.prototype.pushProvider = function (a) {
    var b = ++this.contextIndex,
        c = a.type._context,
        f = this.threadID;
    F(c, f);
    var e = c[f];
    this.contextStack[b] = c;
    this.contextValueStack[b] = e;
    c[f] = a.props.value;
  };

  a.prototype.popProvider = function () {
    var a = this.contextIndex,
        d = this.contextStack[a],
        c = this.contextValueStack[a];
    this.contextStack[a] = null;
    this.contextValueStack[a] = null;
    this.contextIndex--;
    d[this.threadID] = c;
  };

  a.prototype.clearProviders = function () {
    for (var a = this.contextIndex; 0 <= a; a--) {
      this.contextStack[a][this.threadID] = this.contextValueStack[a];
    }
  };

  a.prototype.read = function (a) {
    if (this.exhausted) return null;
    var b = X;
    X = this.threadID;
    var c = Ia.current;
    Ia.current = Aa;

    try {
      for (var f = [""], e = !1; f[0].length < a;) {
        if (0 === this.stack.length) {
          this.exhausted = !0;
          var h = this.threadID;
          G[h] = G[0];
          G[0] = h;
          break;
        }

        var g = this.stack[this.stack.length - 1];

        if (e || g.childIndex >= g.children.length) {
          var D = g.footer;
          "" !== D && (this.previousWasTextNode = !1);
          this.stack.pop();
          if ("select" === g.type) this.currentSelectValue = null;else if (null != g.type && null != g.type.type && g.type.type.$$typeof === z) this.popProvider(g.type);else if (g.type === A) {
            this.suspenseDepth--;
            var B = f.pop();

            if (e) {
              e = !1;
              var n = g.fallbackFrame;
              n ? void 0 : r("303");
              this.stack.push(n);
              continue;
            } else f[this.suspenseDepth] += B;
          }
          f[this.suspenseDepth] += D;
        } else {
          var l = g.children[g.childIndex++],
              k = "";

          try {
            k += this.render(l, g.context, g.domNamespace);
          } catch (t) {
            throw t;
          } finally {}

          f.length <= this.suspenseDepth && f.push("");
          f[this.suspenseDepth] += k;
        }
      }

      return f[0];
    } finally {
      Ia.current = c, X = b;
    }
  };

  a.prototype.render = function (a, d, c) {
    if ("string" === typeof a || "number" === typeof a) {
      c = "" + a;
      if ("" === c) return "";
      if (this.makeStaticMarkup) return M(c);
      if (this.previousWasTextNode) return "\x3c!-- --\x3e" + M(c);
      this.previousWasTextNode = !0;
      return M(c);
    }

    d = Ra(a, d, this.threadID);
    a = d.child;
    d = d.context;
    if (null === a || !1 === a) return "";

    if (!q.isValidElement(a)) {
      if (null != a && null != a.$$typeof) {
        var b = a.$$typeof;
        b === ba ? r("257") : void 0;
        r("258", b.toString());
      }

      a = Z(a);
      this.stack.push({
        type: null,
        domNamespace: c,
        children: a,
        childIndex: 0,
        context: d,
        footer: ""
      });
      return "";
    }

    b = a.type;
    if ("string" === typeof b) return this.renderDOM(a, d, c);

    switch (b) {
      case ca:
      case fa:
      case da:
      case x:
        return a = Z(a.props.children), this.stack.push({
          type: null,
          domNamespace: c,
          children: a,
          childIndex: 0,
          context: d,
          footer: ""
        }), "";

      case A:
        r("294");
    }

    if ("object" === typeof b && null !== b) switch (b.$$typeof) {
      case ha:
        N = {};
        var e = b.render(a.props, a.ref);
        e = va(b.render, a.props, e, a.ref);
        e = Z(e);
        this.stack.push({
          type: null,
          domNamespace: c,
          children: e,
          childIndex: 0,
          context: d,
          footer: ""
        });
        return "";

      case ia:
        return a = [q.createElement(b.type, p({
          ref: a.ref
        }, a.props))], this.stack.push({
          type: null,
          domNamespace: c,
          children: a,
          childIndex: 0,
          context: d,
          footer: ""
        }), "";

      case z:
        return b = Z(a.props.children), c = {
          type: a,
          domNamespace: c,
          children: b,
          childIndex: 0,
          context: d,
          footer: ""
        }, this.pushProvider(a), this.stack.push(c), "";

      case ea:
        b = a.type;
        e = a.props;
        var h = this.threadID;
        F(b, h);
        b = Z(e.children(b[h]));
        this.stack.push({
          type: a,
          domNamespace: c,
          children: b,
          childIndex: 0,
          context: d,
          footer: ""
        });
        return "";

      case ja:
        r("295");
    }
    r("130", null == b ? b : typeof b, "");
  };

  a.prototype.renderDOM = function (a, d, c) {
    var b = a.type.toLowerCase();
    c === Ba.html && Ca(b);
    La.hasOwnProperty(b) || (Ka.test(b) ? void 0 : r("65", b), La[b] = !0);
    var e = a.props;
    if ("input" === b) e = p({
      type: void 0
    }, e, {
      defaultChecked: void 0,
      defaultValue: void 0,
      value: null != e.value ? e.value : e.defaultValue,
      checked: null != e.checked ? e.checked : e.defaultChecked
    });else if ("textarea" === b) {
      var h = e.value;

      if (null == h) {
        h = e.defaultValue;
        var g = e.children;
        null != g && (null != h ? r("92") : void 0, Array.isArray(g) && (1 >= g.length ? void 0 : r("93"), g = g[0]), h = "" + g);
        null == h && (h = "");
      }

      e = p({}, e, {
        value: void 0,
        children: "" + h
      });
    } else if ("select" === b) this.currentSelectValue = null != e.value ? e.value : e.defaultValue, e = p({}, e, {
      value: void 0
    });else if ("option" === b) {
      g = this.currentSelectValue;
      var D = Na(e.children);

      if (null != g) {
        var B = null != e.value ? e.value + "" : D;
        h = !1;
        if (Array.isArray(g)) for (var n = 0; n < g.length; n++) {
          if ("" + g[n] === B) {
            h = !0;
            break;
          }
        } else h = "" + g === B;
        e = p({
          selected: void 0,
          children: void 0
        }, e, {
          selected: h,
          children: D
        });
      }
    }
    if (h = e) Ea[b] && (null != h.children || null != h.dangerouslySetInnerHTML ? r("137", b, "") : void 0), null != h.dangerouslySetInnerHTML && (null != h.children ? r("60") : void 0, "object" === typeof h.dangerouslySetInnerHTML && "__html" in h.dangerouslySetInnerHTML ? void 0 : r("61")), null != h.style && "object" !== typeof h.style ? r("62", "") : void 0;
    h = e;
    g = this.makeStaticMarkup;
    D = 1 === this.stack.length;
    B = "<" + a.type;

    for (y in h) {
      if (Oa.call(h, y)) {
        var l = h[y];

        if (null != l) {
          if ("style" === y) {
            n = void 0;
            var k = "",
                t = "";

            for (n in l) {
              if (l.hasOwnProperty(n)) {
                var m = 0 === n.indexOf("--"),
                    u = l[n];

                if (null != u) {
                  var w = n;
                  if (Ma.hasOwnProperty(w)) w = Ma[w];else {
                    var R = w.replace(Ga, "-$1").toLowerCase().replace(Ha, "-ms-");
                    w = Ma[w] = R;
                  }
                  k += t + w + ":";
                  t = n;
                  m = null == u || "boolean" === typeof u || "" === u ? "" : m || "number" !== typeof u || 0 === u || Y.hasOwnProperty(t) && Y[t] ? ("" + u).trim() : u + "px";
                  k += m;
                  t = ";";
                }
              }
            }

            l = k || null;
          }

          n = null;

          b: if (m = b, u = h, -1 === m.indexOf("-")) m = "string" === typeof u.is;else switch (m) {
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
              m = !1;
              break b;

            default:
              m = !0;
          }

          if (m) Pa.hasOwnProperty(y) || (n = y, n = qa(n) && null != l ? n + "=" + ('"' + M(l) + '"') : "");else {
            m = y;
            n = l;
            l = J.hasOwnProperty(m) ? J[m] : null;
            if (u = "style" !== m) u = null !== l ? 0 === l.type : !(2 < m.length) || "o" !== m[0] && "O" !== m[0] || "n" !== m[1] && "N" !== m[1] ? !1 : !0;
            u || sa(m, n, l, !1) ? n = "" : null !== l ? (m = l.attributeName, l = l.type, n = 3 === l || 4 === l && !0 === n ? m + '=""' : m + "=" + ('"' + M(n) + '"')) : n = qa(m) ? m + "=" + ('"' + M(n) + '"') : "";
          }
          n && (B += " " + n);
        }
      }
    }

    g || D && (B += ' data-reactroot=""');
    var y = B;
    h = "";
    Da.hasOwnProperty(b) ? y += "/>" : (y += ">", h = "</" + a.type + ">");

    a: {
      g = e.dangerouslySetInnerHTML;

      if (null != g) {
        if (null != g.__html) {
          g = g.__html;
          break a;
        }
      } else if (g = e.children, "string" === typeof g || "number" === typeof g) {
        g = M(g);
        break a;
      }

      g = null;
    }

    null != g ? (e = [], Ja[b] && "\n" === g.charAt(0) && (y += "\n"), y += g) : e = Z(e.children);
    a = a.type;
    c = null == c || "http://www.w3.org/1999/xhtml" === c ? Ca(a) : "http://www.w3.org/2000/svg" === c && "foreignObject" === a ? "http://www.w3.org/1999/xhtml" : c;
    this.stack.push({
      domNamespace: c,
      type: b,
      children: e,
      childIndex: 0,
      context: d,
      footer: h
    });
    this.previousWasTextNode = !1;
    return y;
  };

  return a;
}(),
    Ta = {
  renderToString: function renderToString(a) {
    a = new Sa(a, !1);

    try {
      return a.read(Infinity);
    } finally {
      a.destroy();
    }
  },
  renderToStaticMarkup: function renderToStaticMarkup(a) {
    a = new Sa(a, !0);

    try {
      return a.read(Infinity);
    } finally {
      a.destroy();
    }
  },
  renderToNodeStream: function renderToNodeStream() {
    r("207");
  },
  renderToStaticNodeStream: function renderToStaticNodeStream() {
    r("208");
  },
  version: "16.8.3"
},
    Ua = {
  default: Ta
},
    Va = Ua && Ta || Ua;

module.exports = Va.default || Va;